package horcrux.common.api.dtos

import horcrux.common.api.dtos.types.DocumentType
import horcrux.common.types.MimeType
import horcrux.common.types.Transmittable
import kotlinx.serialization.Serializable

@Serializable
class RawDocument(override val byteArray: ByteArray, val documentType: DocumentType) : Transmittable {
    override val mimeType: MimeType
        get() = documentType.mimeType

    override fun toString(): String = "RawDocument<byteArray=<${byteArray.size}>, documentType=$documentType)"
}
